import { CreditCard, FileText, Shield } from "lucide-react";
import type { LucideIcon } from "lucide-react";

type HelpfulInfoItem = {
  id: string;
  icon: LucideIcon;
  title: string;
  description: string;
};

// TODO: replace with copy driven by the group/plan configuration.
const MOCK_HELPFUL_INFO: HelpfulInfoItem[] = [
  {
    id: "network",
    icon: Shield,
    title: "Compare In-Network vs Out-of-Network",
    description:
      "In-Network providers often save you 30%-50% on procedures compared to out-of-network care.",
  },
  {
    id: "deductible",
    icon: FileText,
    title: "Check Your Deductible Status",
    description:
      "If you've already met your deductible, many services may be covered at 100%",
  },
  {
    id: "payment-plan",
    icon: CreditCard,
    title: "Ask About Payment Plan",
    description:
      "Many providers offer interest-free financing options for large medical bills.",
  },
];

export const HcbbHelpfulInfo = () => {
  return (
    <div>
      <h2 className="mb-2 font-medium">Helpful Info</h2>
      <div className="flex justify-between gap-4">
        {MOCK_HELPFUL_INFO.map((item) => (
          <InfoBoxItem
            key={item.id}
            icon={item.icon}
            title={item.title}
            description={item.description}
          />
        ))}
      </div>
    </div>
  );
};

const InfoBoxItem = ({
  icon: Icon,
  title,
  description,
}: Omit<HelpfulInfoItem, "id">) => {
  return (
    <div className="border-1 items-center space-y-2 rounded-lg border px-4 py-3 shadow-md">
      <div className="text-primary">
        <Icon aria-hidden="true" />
      </div>
      <h3 className="font-medium">{title}</h3>
      <p className="text-sm text-gray-600">{description}</p>
    </div>
  );
};
